import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicChallengeBySlugV4ResponseSchema,
  type IChallengeV4,
} from './get-public-challenge-by-slug-v4-response';

export async function getPublicChallengeBySlugV4Api(slug: string) {
  return getRequest<IAPI<IChallengeV4>>({
    path: `/challenges/v4/slug/${encodeURIComponent(slug)}`,
    schema: getPublicChallengeBySlugV4ResponseSchema,
  });
}
